import { gql } from '@apollo/client';

export const GET_PBI_REPORTS_QUERY = gql`
  query getPBIReportsQuery($group_id: String, $company_id: String, $id: String) {
    pbi_reports(group_id: $group_id, company_id: $company_id, id: $id) {
      id
      name
      dataset_id
      embed_url
      view
      company {
        id
        name
        group {
          id
          name
        }
      }
      deleted
    }
  }
`;
